import { Expose, Transform, TransformPlainToClass } from 'class-transformer';

import { ExposeFunction, ExposeRawData } from '@lib/common/decorators';
import { SnRoute } from '@lib/state/router';
import { SnBadge } from '@lib/ui/badge';
import { SnIcon } from '@lib/ui/icon';
import { SnMenu } from '@lib/ui/menu';

import {
  SnActionConfig,
  SnActionClickHandler,
  SnActionHideExpression,
  SnActionDisableExpression,
} from '../types';

export class SnAction<D = any> {
  @Expose()
  public readonly label: string;

  @Expose()
  public readonly color: string;

  @Expose()
  public readonly class: string | (() => string);

  @Expose()
  @Transform((value, data) => SnIcon.fromConfig(data.icon))
  public readonly icon: SnIcon;

  @Expose()
  @Transform((value, data) => SnBadge.fromConfig(data.badge))
  public readonly badge: SnBadge;

  @Expose()
  @Transform((value, data) => SnRoute.fromConfig(data.route))
  public readonly route: SnRoute;

  @Expose()
  @Transform((value, data) => SnMenu.fromConfig(data.menu))
  public readonly menu: SnMenu;

  @ExposeRawData({ default: false })
  public readonly collapse: boolean | string;

  @ExposeFunction()
  public readonly click: SnActionClickHandler<D>;

  @ExposeFunction()
  public readonly hidden: SnActionHideExpression<D>;

  @ExposeFunction()
  public readonly disabled: SnActionDisableExpression<D>;

  @TransformPlainToClass(SnAction, { strategy: 'excludeAll' })
  public static fromConfig(config: SnActionConfig): SnAction {
    return config as SnAction;
  }

  constructor() {}
}
